/**
 * The `.tres` files, the font files and the project fonts a mesh build reads, loaded together: a
 * font plan may read a file the first plan loaded, as a CSG shape's mesh names its font. A caller
 * that needs no font passes `readsFonts` false, and the hook listens to no font bus.
 */
import { useCallback } from 'react';
import { FONT_FILES, useCachedFiles, useLoadedFiles } from './useLoadedFiles';
import { useProjectFonts } from './useProjectFonts';
/** A caller keeps both plans stable while their inputs hold, as `useLoadedFiles` asks. */
export function useLoadedFilesAndFonts(filesPlan, fontsPlan, readsFonts) {
    const files = useLoadedFiles(filesPlan);
    const { projectFonts, isLoading: isLoadingProjectFonts } = useProjectFonts(readsFonts);
    const readFonts = useCallback((loadedFont) => fontsPlan(loadedFont, files.loadedFile, projectFonts), [fontsPlan, files.loadedFile, projectFonts]);
    const fonts = useCachedFiles(readsFonts ? FONT_FILES : null, readFonts);
    const isLoadingFonts = fonts.isLoading || isLoadingProjectFonts;
    return {
        loadedFile: files.loadedFile,
        loadedFont: fonts.loadedFile,
        projectFonts,
        isLoading: files.isLoading || isLoadingFonts,
        isLoadingFonts,
    };
}
//# sourceMappingURL=useLoadedFilesAndFonts.js.map